<div class="scroll-container"
     (mousedown)="onDragStart($event)"
     (mouseleave)="onDragLeave()">
  <div class="scroll-content" #scrollContent>
    @for (block of visibleBlocks; track $index; ) {
      <img class="block" [src]="block.src" [alt]="block.alt" [attr.data-index]="$index">
    }
  </div>
</div>
